import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(true); // For demo, always authenticated
  const [isLoading, setIsLoading] = useState(false); // No loading for demo

  return { isAuthenticated, isLoading };
};